// eslint-disable-next-line no-useless-concat
const getAssetUrl = (assetPath) => `${process.env.PUBLIC_URL}` + `${assetPath}`

export {
  getAssetUrl
}